<template>
    <div class="news-nav-bottom" >
        <h3>相关新闻</h3>
        <ul>
            <li v-for="item in xgNews" @click="newsShow(item.id)" :key="item.id">
                <img :src="item.image" alt="">
                <p>{{item.title}}</p>
                <span>{{item.createtime}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'NewsNavBottom',
    props:{
        xgNews: Array
    },
    data () {
        return {
        }
    },
    methods: {
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        newsShow (id) {
            this.$router.push('/newsdetail/'+id);
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .news-nav-bottom
        box-sizing: border-box
        background-color: #fff
        border: 1px solid #ccc
        width: 100%
        padding: 56px 48px 59px
        h3
            font-size: 18px
            font-weight: 600
            margin-bottom: 40px
            line-height: 1em
            letter-spacing: 1px
            color: #333 
        ul
            li
                cursor: pointer
                font-size: 16px
                margin: 0 0 57px
                img
                    vertical-align: middel
                    width: 100%
                    margin: 0.8em 0
                p
                    line-ellipsis()
                    color: #666
                    font-size: 14px
                    margin: 19px 0 11px
                span
                    font-size: 12px
                    color: #999
            li:last-of-type
                margin-bottom: 0

</style>


// WEBPACK FOOTER //
// src/components/pc/NewsNavBottom.vue